import { $themeBreakpoints } from '@theme-config'
import { remoteConfig } from '@/shared/services/firebase'

export default {
  namespaced: true,
  state: {
    name: 'hw-admin',
    windowWidth: 0,
    webVersion: localStorage.getItem('webAdminClientVersion'),
    appConfig: {
      type: "",
      name: "",
    },
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_APP_NAME(state, val) {
      state.name = val
    },
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    SET_VERSION_DATA(state, val) {
      state.versionData = val
    },
    SET_APP_CONFIG(state, val) {
      state.appConfig = val
    }
  },
  actions: {
    async getVersionData(ctx) {
      await remoteConfig.fetchAndActivate()
      const appConfig = JSON.parse(remoteConfig.getValue('versionData').asString())
      
      ctx.commit("UPDATE_APP_NAME", appConfig.type)
      ctx.commit("SET_APP_CONFIG", appConfig)
    },
  },
}
